export default "__VITE_ASSET__DdtxH2zJ__"